import createReactModal, { MODAL_SIZE } from './../../modal/createReactModal'
import ServiceAppointmentModal from './ServiceAppointmentModal.jsx'
import { createLoader, removeLoader } from '../../loader'
import { createServiceAppointmentPreview } from './createServiceAppointmentPreview'
import createModal from './../../modal/createModal'
import { ajax } from '../../ajax'
import { _ } from '../../gettext'
import moment from 'moment'
import { DATE_TIME_FORMAT } from '../../services/utils/dateTime'

/**
 * Creates service appointment form component in modal.
 *
 * @param {object|null}     reservation
 * @param {string|null}     ticketId                - data also loaded for form service of given ticket
 * @param {string|null}     defaultFrom
 * @param {string|null}     defaultTo
 * @param {array|null}      defaultEquipment
 * @param {boolean}         canManageMeasurements
 * @param {function|null}   onAfterSave
 * @param {function|null}   onAfterDelete
 * @param {function|null}   onCopy
 * @param {boolean}         copy
 * @param {string|null}     defaultFormService
 * @param {string|null}     defaultRealisedFor
 * @param {string|null}     defaultProject
 * @param {string|null}     defaultResearchGroup
 *
 * @deprecated
 */
export function createServiceAppointmentModal (
  reservation = null,
  ticketId = null,
  defaultFrom = null,
  defaultTo = null,
  defaultEquipment = null,
  canManageMeasurements = false,
  onAfterSave = null,
  onAfterDelete = null,
  onCopy = null,
  copy = false,
  defaultFormService = null,
  defaultRealisedFor = null,
  defaultProject = null,
  defaultResearchGroup = null) {
  return createReactModal(
    (modal) => {
      if (!defaultFrom && !defaultTo) {
        defaultFrom = moment().add(5, 'minutes').format(DATE_TIME_FORMAT)
        defaultTo = moment().add(35, 'minutes').format(DATE_TIME_FORMAT)
      }
      return (<ServiceAppointmentModal
        reservation={reservation}
        ticketId={ticketId}
        defaultFrom={defaultFrom}
        defaultTo={defaultTo}
        defaultEquipment={defaultEquipment}
        defaultFormService={defaultFormService}
        defaultRealisedFor={defaultRealisedFor}
        defaultProject={defaultProject}
        defaultResearchGroup={defaultResearchGroup}
        modal={modal}
        onAfterSave={onAfterSave}
        onAfterDelete={onAfterDelete}
        onCopy={onCopy}
        copy={copy}
      />)
    },
    {
      title: reservation !== null
        ? _('Editace rezervace') + ' ' + reservation.model.subject +
          (
            canManageMeasurements
              ? ' <a href="#" class="btn btn-xs btn-info btn-session-picker" data-id="' +
                reservation.model.id + '">' + _('Měření') + '</a>'
              : ''
          )
        : _('Nová rezervace'),
      contentWithFooter: true,
      contentSizeClass: MODAL_SIZE.XL,
    },
  )
}

/**
 * Loads reservation by GUID a then shows it in Modal.
 *
 * @param {string}        reservationId
 * @param {object|null}   calendar
 * @param {boolean}       copy
 * @param {string|null}   ticketId
 * @param {function|null} onAfterSave
 * @param {function|null} onAfterDelete
 *
 * @deprecated
 */
export function loadServiceAppointmentModal (
  reservationId,
  calendar = null,
  copy = false,
  ticketId = null,
  onAfterSave = null,
  onAfterDelete = null
) {
  createLoader()
  ajax({ url: `/api-deprecated/service-appointment/${reservationId}/` })
    .then(({ data }) => {
      if (data.status === 'accessError') {
        removeLoader()
        createServiceAppointmentPreview(data).show()
      } else if (data.status === 'error') {
        removeLoader()
        createModal(_('Upozornění'), data.message).show()
      } else {
        createServiceAppointmentModal(
          data,
          ticketId,
          null,
          null,
          null,
          $('body').hasClass('can-manage-measurements'),
          (modal) => {
            modal.hide()
            if (onAfterSave) {
              onAfterSave()
            } else {
              removeLoader()
              if (calendar !== null) {
                calendar.refetchEvents()
              }
            }
          },
          (modal) => {
            modal.hide()
            if (onAfterDelete) {
              onAfterDelete()
            } else {
              removeLoader()
              if (calendar !== null) {
                calendar.refetchEvents()
              }
            }
          },
          (modal) => {
            modal.hide()
            loadServiceAppointmentModal(reservationId, calendar, true, ticketId)
          },
          copy
        ).show()
      }
    })
}
